import React, {useEffect, useState} from "react";
import GenericForm from "Admin/components/GenericForm";
import { GenGet } from "state/api";
import LoadingState from "Admin/components/LoadingState";
import MsgAlert from "Admin/components/MsgAlert";

function CreateProfissionais() {
  const [userLookup, setUserLookup] = useState([]);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleUserLookup = async (endpoint, payload) => {
    try {
      const response = await GenGet(endpoint);
      console.log(response)
      setLoading(false);
      setUserLookup(response)

    } catch (err) {
      setMsg("Erro ao bucar usuários");
      setLoading(false);
      setTimeout(() => setMsg(null), 3000);
    }
  };

  useEffect(() => {
    handleUserLookup('/users/lookup')
  }, []);

  if (loading) {
    return (
      <LoadingState />
    )
  }

  return (
    <>
    <GenericForm
      title="Cadastro de Profissionais"
      description="Preencha as informações do profissional"
      endpoint="/novoprofissional"
      fields={[
        { name: "Informações", label: "informações de usuário", type: "title", default: true },
        { name: "nome", label: "Nome", type: "text", required: true },
        { name: "email", label: "E-mail", type: "email", required: true },
        { name: "senha", label: "Senha", type: "password", required: true },
        { name: "user_id", label: "Usuário", type: "custom-select", options: userLookup, required: true, search:true },
        
        { name: "Perfil", label: "perfil de usuário", type: "title", default: true },
        { name: "status", label: "Ativo", type: "checkbox", default: true },
        { name: "receber_agendamento", label: "Receber Agendamento", type: "checkbox", default: false },
        { name: "ver_todas_agendas", label: "Ver Todas as Agendas", type: "checkbox", default: false },
        { name: "receber_email_agendamento", label: "Receber E-mail de Agendamento", type: "checkbox", default: false },
        { name: "permite_alternar_caixas", label: "Permite Alternar Caixas", type: "checkbox", default: false },
      ]}
    />
    <MsgAlert alert={msg} />
    </>

  );
}

export default CreateProfissionais;